export default "__VITE_ASSET__dk76hxy0__"